import { render, staticRenderFns } from "./tenant-color.vue?vue&type=template&id=2afd83c3&scoped=true&"
import script from "./tenant-color.vue?vue&type=script&lang=js&"
export * from "./tenant-color.vue?vue&type=script&lang=js&"
import style0 from "./tenant-color.vue?vue&type=style&index=0&id=2afd83c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd83c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VAlert,VBtn,VColorPicker})
